const cognitoConfig = {
  domain: `https://${process.env.REACT_APP_POOL_AUTH_URL}`,
  clientId: process.env.REACT_APP_POOL_CLIENT_ID,
  userPoolId: process.env.REACT_APP_POOL_ID,
  redirectUri: `${window.location.origin}/callback`,
  logoutUri: window.location.origin,
  scope: "openid email profile",
};

export default cognitoConfig;
